module.exports = __webpack_public_path__ + "static/media/iconshangla.ac3377b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/iconshangla.png
// module id = 2170
// module chunks = 0